module.exports = __webpack_public_path__ + "img/anniversaire3.db135b10.jpg";